import { MainMediaActions } from './constants'

export const mainMediaClicked = _ => ({
    type: MainMediaActions.MAIN_MEDIA_CLICKED,
})
